export enum UserValid4Sandbox{
    VALID_USER,
    MAIL_TEST_MISSING,
    INVALID_USER
}  